import React, { useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";

const ViewContainer = styled.div`
  min-height: 50vh;
  max-height: 90vh;
  &.card {
    height: 100%;
  }
`;

const HeaderDiv = styled.div`
  display: flex & .title {
    flex: 100% 1 1;
    padding-right: 2.5ch;
  }
`;

const ContextMenu = ({ Help = null, options = [] }) => {
  const actions = useContext(ActionsContext);
  const sends =
    (...args) =>
    (/*click event*/) =>
      actions.send(...args);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      {Help === null ? null : (
        <li>
          <a
            onClick={() => actions.send("open-help")}
            data-toggle="cardloading"
            data-loading-effect="pulse"
            title="Refresh"
          >
            <i className="material-icons">help_outline</i>
          </a>
        </li>
      )}
      <li>
        <a
          onClick={sends("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
      {options.length === 0 ? null : (
        <li className="dropdown hidden-to-operators">
          <a
            className="dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            title="Options"
          >
            <i className="material-icons">more_vert</i>
          </a>
          <ul className="dropdown-menu pull-right">
            {options.map(({ label, signal }) => (
              <li key={signal}>
                <a onClick={sends(signal)} >
                  {label}...
                </a>
              </li>
            ))}
          </ul>
        </li>
      )}
    </ul>
  );
};
const View = ({
  title,
  Help = null,
  className = "",
  options = [],
  children,
}) => (
  <ViewContainer className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div className={`card ${className}`}>
      <HeaderDiv className="header block-header">
        <h2 className="title">{title}</h2>
        <ContextMenu Help={Help} options={options} />
      </HeaderDiv>
      <div className="body flex-panel-column">{children}</div>
    </div>
    {Help === null ? null : <Help />}
  </ViewContainer>
);

export default View;
